import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import largeExitIcon from '../../img/large-exit-icon.svg';

class BaseModal extends React.Component {
    constructor(props) {
      super(props);
      this.onKey = this.onKey.bind(this);
      this.onClose = this.onClose.bind(this);
    }

    onClose() {
        document.removeEventListener("keydown", this.onKey);
        this.props.onClose();
    }

    onKey(event) {
        if (event.key === "Escape") {
          this.onClose();
        }
    }

    componentDidMount() {
      document.addEventListener("keydown", this.onKey);
      window.onpopstate = this.onClose;
    }

    componentWillUnmount() {
      document.removeEventListener("keydown", this.onKey);
      window.onpopstate = null;
    }

    modalContents() {
      return (
        <div key="modal-content" className="fullscreen-modal-content" aria-modal={true} aria-haspopup={"dialog"}>
          <div className="fullscreen-modal-header">
            <div className="fullscreen-modal-close" onClick={this.onClose}>
              <img className="fullscreen-modal-close-icon" src={largeExitIcon} alt="Close" aria-label="Close" />
              <span className="fullscreen-modal-close-label">or esc</span>
            </div>
          </div>
          {this.props.children}
        </div>
      );
    }

    render() {
      document.body.style.overflowY = this.props.open ? 'hidden' : 'auto';

      if (!this.props.open) {
        return null;
      }

      return (
        <TransitionGroup component={null}>
          <CSSTransition
            key="modal"
            classNames="fade"
            timeout={{ enter: 200, exit: 300 }}>
            <section className="fullscreen-modal" aria-modal={true} aria-haspopup={"dialog"}>
              <CSSTransition
                key="modal-content"
                classNames="slidein"
                timeout={{ enter: 400, exit: 600 }}>
                {this.modalContents()}
              </CSSTransition>
            </section>
          </CSSTransition>
        </TransitionGroup>
      );
    }
}

export default BaseModal;
